import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormPromoter } from '../components/Form'
import { apiGetByIdUpdatePage } from '../domain/api'
import { nameActions, PROMOTER_USER_ROLE_ENUM } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

const PromoterUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [promoterItem, setPromoterItem] = useState<{
    id: string
    name: string
    cpf: string
    pix_key?: string | null
    phone_number?: string | null
    commission_per_process: number
    promoterUser: {
      id: number
      name: string
      email: string
      password?: string
      role: PROMOTER_USER_ROLE_ENUM
    }
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiGetByIdUpdatePage(id))
        const { data } = response
        setPromoterItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o usuário',
          description:
            'Houve um error ao carregar o usuário, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormPromoter
        typeForm="update"
        initialValues={
          promoterItem
            ? {
                idUpdate: Number(promoterItem?.id),
                ...promoterItem
              }
            : undefined
        }
      />
    </Container>
  )
}

export default PromoterUpdate
